import React from "react";
import { Form, Select } from "antd";

export default function AppSelect({
  name,
  label,
  rules,
  options = [],
  placeholder,
  onChange,
  ...rest
}) {
  return (
    <Form.Item name={name} label={label} rules={rules}>
      <Select
        placeholder={placeholder}
        options={options}
        onChange={onChange}
        {...rest}
      />
    </Form.Item>
  );
}
